import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.5 10.9844L12 15.4844L7.5 10.9844"
        stroke="var(--svg-color-main, black)"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}
